import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ConnectWalletButton from "components/ConnectWalletButton";
import { useWeb3React } from "@web3-react/core";
import { useContract } from "hooks/useContract";
import { getBalanceNumber } from "utils/formatBalance";
import { BigNumber } from "ethers";
import { Text } from "@pancakeswap-libs/uikit";
import Countdown from "react-countdown";

import TokenAbi from "./abi.json";


const digits = BigNumber.from(10).pow(18);

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Home = ({ videoPlayed, setVideoPlayed }) => {
  const { account } = useWeb3React();
  const tokenContract = useContract(
    TokenAbi,
    "0xe256BD60F15e2BD94E85a26984A4176070Bff6F4",
  );
  // @ts-ignore
  const [limit, setLimit] = useState("0");
  const [resetTime, setResetTime] = useState(0);
  const [randomNumber, setRandomNumber] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      // if account, See if already claimed
      if (account) {
        // these return strings
        const sellLimit = await tokenContract.methods
          .antiChadLimit(account)
          .call();
        const sellTime = await tokenContract.methods.sellTime(account).call();
        setLimit(sellLimit);
        setResetTime(Number(sellTime) * 1000 + 86400000);
        console.log("sellLimit", sellLimit, typeof sellLimit);
        console.log("sellTime", sellTime, Number(new Date()));
      }
    };
    fetchData();
  }, [account, tokenContract, randomNumber]);

  // @ts-ignore
  const formattedSellLimit = BigNumber.from(limit)
    .div(digits)
    .toNumber()
    .toLocaleString("en-US", { maximumFractionDigits: 2 });

    console.log('Number(new Date()) < resetTime', Number(new Date()), resetTime, Number(new Date()) < resetTime)

  return (
    <Wrapper
      id="swap-page"
      style={{ padding: 5, display: "flex", flexDirection: "column" }}
    >
      {account ? (
        <>
          <Text>Your Current Sell Limit: {formattedSellLimit} CHAD</Text>
          <br/>
          {
            Number(new Date()) < resetTime ? 
            <Countdown
              date={resetTime}
              onMount={({ completed }) => {
                if (completed) {
                  setRandomNumber(Math.random());
                }
              }}
              onComplete={() => setRandomNumber(Math.random())}
              // @ts-ignore
              renderer={renderCounter}
            /> : <Text>per 24 hours</Text>
          }
          <br/>
          <InfoText style={{fontSize:12}}>
            * limits are dynamic and determined as a percentage of available liquidity
          </InfoText>
        </>
      ) : (
        <ConnectWalletButton mt="8px" width="100%" label="Connect" />
      )}
    </Wrapper>
  );
};

export default Home;


const InfoText = styled.div`
color: white;
font-size: 14px;
`

const renderCounter = (
  { days, hours, minutes, seconds, completed }: any
) => {
  if (completed) {
    return <></>;
  }
  return (
    <InfoText>
      <br/>
      Your sell limit expires in: {days}d {hours}h {minutes}m {seconds}s
    </InfoText>
  );
};
